import React, {useState, useEffect, useRef} from "react";
import {Popup, Checkbox, Input} from 'antd-mobile';
import {AddSquareOutline, LeftOutline, SearchOutline} from "antd-mobile-icons";
import {message, Space, Spin} from "antd";
import {useDebounceEffect, useDebounceFn, useRequest, useScroll} from "ahooks";
import {TOrganizationPeople} from "@/types/exam_signup";
import {apiGetOrganizationPeople} from "@/services/exam_signup";
import styles from 'src/page-components/detail/Intro/styles.module.less';

type TMobileOrganizationSelectList = {
  certId: string;
  selectUser:TOrganizationPeople[];
  onSubmit:(data:TOrganizationPeople[]) => void;
  onChange?:(data:TOrganizationPeople[])=>void;
}

const PAGE_SIZE = 10;

const MobileOrganizationSelectList:React.FC<TMobileOrganizationSelectList> = ({certId,onChange,selectUser,onSubmit}) => {
  const [visible, setVisible] = useState(false);
  const [state, setState] = useState<{
    userList: TOrganizationPeople[],
    pagination:{
      current: number;
      total: number;
    }
  }>({
    userList: [],
    pagination:{
      current:0,
      total: 0
    }
  })
  const [selectUserList, setSelectUserList] = useState<any[]>([]);
  const {run,loading} = useRequest((current,search=undefined) => {
    if (search){
      return apiGetOrganizationPeople(certId,current,search)
    }
    return apiGetOrganizationPeople(certId,current)
  },{
    manual: true,
    onError:() => {
      message.warning('获取组织成员列表失败');
    },
    onSuccess:(res,params) => {
      if (res.code === 200){
        const result = res.data.list;
        setState(prevState => (
          {
            ...prevState,
            pagination:{...state.pagination,current:params[0],total: res.data.total},
            userList:state.userList.concat(result).map(item => ({...item,disabled: !item.isSignup,name:item.realname !== null ? item.realname : item.username}))
          }));
      } else {
        message.warning('获取组织成员列表失败');
      }
    }
  })
  const {run:doSearch} = useRequest((current,search) => {
    return apiGetOrganizationPeople(certId,current,search)
  },{
    manual: true,
    onError:() => {
      message.warning('获取组织成员列表失败');
    },
    onSuccess:(res,params) => {
      if (res.code === 200){
        const result = res.data.list;
        setState(prevState => (
          {
            ...prevState,
            pagination:{...state.pagination,current:params[0],total: res.data.total},
            userList:result.map(item => ({...item,disabled: !item.isSignup,name:item.realname !== null ? item.realname : item.username}))
          }));
      } else {
        message.warning('获取组织成员列表失败');
      }
    }
  })
  useEffect(() => {
    if (certId){
      run(1)
    }
  }, [certId]);
  useEffect(() => {
    console.log('selectUser是');
    console.log(selectUser);
    if (selectUser && Array.isArray(selectUser)){
      setSelectUserList(selectUser.map(item => item.id));
    }
  }, [selectUser]);
  const ref = useRef(null);
  const scroll = useScroll(ref,() => visible);
  const { run: handleOnScroll } = useDebounceFn(
    async() => {
      await run(state.pagination.current+1)
    },
    {
      wait: 500,
    },
  );
  const handleScroll = async (scollDis: number) => {
    if(ref.current){
      const {scrollHeight, clientHeight} = ref.current as HTMLElement;
      if (!loading && visible && Math.abs(scrollHeight - clientHeight) - scollDis < 50){
        await handleOnScroll()
      }
    }
  }
  if (scroll){
    handleScroll(scroll.top)
  }
  useDebounceEffect(
    () => {
      if (scroll){
        handleScroll(scroll.top)
      }
    },
    [scroll],
    {
      wait: 1000,
    },
  );


  return (
    <>
      <Space className={styles.header_btn} onClick={() => {
        setVisible(true);
      }}>
        <AddSquareOutline />
        {selectUser.length === 0 ? '点击选择' : `已选${selectUser.length}人`}
      </Space>
      <Popup
        forceRender
        visible={visible}
        afterShow={() => {
        }}
        onMaskClick={() => {
          setVisible(false);
        }}
        position='bottom'
        bodyClassName={styles.signup_modal_mobile}
      >
        <div className={styles.organization_select_popup}>
          <div className={styles.organization_select_popup_header}>
            <LeftOutline className={styles.header_icon} onClick={() => {
              setVisible(false);
            }}/>
            <p className={styles.header_title}>可选{state.pagination.total}人</p>
            <span className={styles.header_submit_btn} onClick={() => {
              const temp:TOrganizationPeople[] = [];
              selectUserList.forEach(value => {
                const item = state.userList.find(user => user.id === value);
                if (item){
                  temp.push(item);
                }
              })
              onSubmit(temp);
              setVisible(false);
            }}>确定（{selectUserList.length}）</span>
          </div>
          <div className={styles.organization_select_popup_body} ref={ref}>
            <div className={styles.search_wrapper}>
              <SearchOutline className={styles.icon}/>
              <Input
                onChange={async (val) => {
                  await doSearch(0,val);
                }}
                placeholder='搜索用户名/姓名/手机号'
                clearable
                className={styles.search_input}
              />
            </div>
            <Checkbox.Group
              value={selectUserList}
              onChange={val => {
                console.log(val);
                const temp:TOrganizationPeople[] = [];
                val.forEach(value => {
                  const item = state.userList.find(user => user.id === value);
                  if (item){
                    temp.push(item);
                  }
                })
                console.log('temp是');
                console.log(temp);
                setSelectUserList(val);
                if (onChange){
                  onChange(temp);
                }
              }}
            >
              <Space direction='vertical' className={styles.list_wrapper}>
                {state.userList.map(user => {
                  return (
                    <Checkbox
                      className={styles.row}
                      value={user.id}
                      key={user.id}
                      disabled={!user.isSignup}
                    >
                      <span className={styles.name_text}>{user.realname !==null ? user.realname : user.username}</span> <span className={styles.mobile_text}>{user.mobile}</span>
                    </Checkbox>
                  )
                })}
              </Space>
            </Checkbox.Group>
            {/*<InfiniteScroll loadMore={async () => {*/}
            {/*  console.log('到底了');*/}
            {/*  // await run(state.pagination.current+1);*/}
            {/*}} hasMore={state.pagination.current*PAGE_SIZE<state.pagination.total} />*/}
          </div>
        </div>
      </Popup>
    </>
  )
}
export default MobileOrganizationSelectList;
